import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import CreatePostPage from './components/CreatePostPage';
import SchedulePostsPage from './components/SchedulePostsPage';
import Analytics from './components/Analytics';
import { DashboardProvider } from './components/Dashboardcontext';
import { AnalyticsProvider } from './components/Analyticscontext';
import AuthPage from './components/AuthPage';
import ProtectedRoute from './components/ProtectedRoute';
import PublicRoute from './components/PublicRoute';

function App() {
  return (
    <DashboardProvider>
      <AnalyticsProvider>
        <BrowserRouter>
          <Routes>
            {/* Public Route - Login/Signup (redirects to /create-post if already logged in) */}
            <Route 
              path="/" 
              element={
                <PublicRoute>
                  <AuthPage />
                </PublicRoute>
              } 
            />
            
            {/* Protected Routes - Require Authentication */}
            <Route 
              path="/create-post" 
              element={
                <ProtectedRoute>
                  <CreatePostPage />
                </ProtectedRoute>
              } 
            />
            
            <Route 
              path="/dashboard" 
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } 
            />
            
            <Route 
              path="/scheduled-posts" 
              element={
                <ProtectedRoute>
                  <SchedulePostsPage />
                </ProtectedRoute>
              } 
            />
            
            <Route 
              path="/analytics" 
              element={
                <ProtectedRoute>
                  <Analytics />
                </ProtectedRoute>
              } 
            />
            
            <Route 
              path="/analytics/:tab" 
              element={
                <ProtectedRoute>
                  <Analytics />
                </ProtectedRoute>
              } 
            />
          </Routes>
        </BrowserRouter>
      </AnalyticsProvider>
    </DashboardProvider>
  );
}

export default App;